import { Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Loading from '@/components/shared/Loading'
import ErrorBoundary from '@/components/shared/ErrorBoundary'
import { ToastContainer } from '@/components/shared/Toast'
import FloatingInviteSprite from '@/components/shared/FloatingInviteSprite'
import InviteConfirmModal from '@/components/shared/InviteConfirmModal'
import Layout from '@/components/layout/Layout'
import { useUserStore } from '@/stores/user'

const HomePage = lazy(() => import('@/pages/home'))
const StakePage = lazy(() => import('@/pages/stake'))
const MePage = lazy(() => import('@/pages/me'))
const WalletPage = lazy(() => import('@/pages/me/wallet'))
const EarningsPage = lazy(() => import('@/pages/me/earnings'))
const TeamPage = lazy(() => import('@/pages/me/team'))
const ArticlesPage = lazy(() => import('@/pages/articles'))
const ArticleDetailPage = lazy(() => import('@/pages/articles/detail'))
const NotificationsPage = lazy(() => import('@/pages/notifications'))
const NodePage = lazy(() => import('@/pages/node'))
const MyOrdersPage = lazy(() => import('@/pages/me/orders'))
const PresalePage = lazy(() => import('@/pages/presale'))
const NotFound = lazy(() => import('@/pages/NotFound'))

function App() {
  const user = useUserStore((s) => s.user)

  return (
    <ErrorBoundary>
      <ToastContainer />
      <InviteConfirmModal />
      {user?.inviteCode && <FloatingInviteSprite inviteCode={user.inviteCode} />}
      <Suspense fallback={<Loading fullScreen />}>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Layout showTabbar><HomePage /></Layout>} />
          <Route path="/stake" element={<Layout showTabbar><StakePage /></Layout>} />
          <Route path="/me" element={<Layout showTabbar><MePage /></Layout>} />
          <Route path="/me/wallet" element={<WalletPage />} />
          <Route path="/me/earnings" element={<EarningsPage />} />
          <Route path="/me/team" element={<TeamPage />} />
          <Route path="/me/orders" element={<MyOrdersPage />} />
          <Route path="/node" element={<Layout showTabbar><NodePage /></Layout>} />
          <Route path="/presale" element={<Layout showTabbar><PresalePage /></Layout>} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:id" element={<ArticleDetailPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}

export default App
